// Module
var code = `<div class="page-item--products">
  <header class="products-header">
    <p class="products-eyebrow">{{eyebrow}}</p>
    <h2 class="products-title">{{title}}</h2>
    <p class="products-subtitle">{{subtitle}}</p>
  </header>

  <div class="products-toolbar">
    <div class="products-filters">
      <label class="products-filter">
        <span class="products-filter__label">{{metalFilterLabel}}</span>
        <select
          class="products-filter__select"
          name="filterMetal"
          data-action="filter"
          data-filter-key="metal"
        >
          <option value="">{{%metalFilterAll%}}</option>
        </select>
      </label>
      <label class="products-filter">
        <span class="products-filter__label">{{originFilterLabel}}</span>
        <select
          class="products-filter__select"
          name="filterOrigin"
          data-action="filter"
          data-filter-key="origin"
        >
          <option value="">{{%originFilterAll%}}</option>
        </select>
      </label>
    </div>
    <p class="products-count" role="status" aria-live="polite">
      <span class="products-count__label">{{showingLabel}}</span>
      <span class="products-count__value"></span>
    </p>
  </div>

  <div class="products-grid"></div>

  <footer class="products-footnote">
    <p class="products-footnote__text">{{footnoteText}}</p>
  </footer>
</div>
`;
// Exports
module.exports = code;